import React, { useState } from 'react';

const CustomerPartsModal = ({ isOpen, onClose, customer, asRecords = [] }) => {
  const [keyword, setKeyword] = useState('');

  if (!isOpen || !customer) return null;

  // 🚀 [실시간 연동] 유형이 부품판매이면서 현재 고객명과 동일한 기록만 필터링
  const partsHistories = asRecords.filter(r => r.customerName === customer.name && r.serviceCategory === '부품판매');
  
  const filteredRecords = partsHistories.filter(p => {
    // 부품 품목 리스트를 글자 하나로 묶어서 키워드 검색 가능하도록 지원
    const partNamesCombined = p.parts ? p.parts.map(item => item.taskName).join(' ') : '';
    return partNamesCombined.toLowerCase().includes(keyword.toLowerCase()) ||
           String(p.mechanic || '').toLowerCase().includes(keyword.toLowerCase());
  });

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(15, 23, 42, 0.6)' }} onClick={onClose} />
      
      <div style={{ position: 'relative', background: 'white', width: '600px', maxHeight: '85vh', borderRadius: '16px', display: 'flex', flexDirection: 'column', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}>
        
        {/* 헤더 */}
        <div style={{ padding: '20px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fefce8', borderRadius: '16px 16px 0 0' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#1e293b' }}>
              📦 {customer.name} 고객 부품 판매 현황 조회
            </h2>
            <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
              {customer.carNumber || '단순 납품 고객'} | {customer.phone}
            </div>
          </div>
          <button onClick={onClose} style={{ padding: '8px 16px', background: '#fef08a', color: '#854d0e', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>닫기 ✖</button>
        </div>

        {/* 상단 부품 검색 바 */}
        <div style={{ padding: '15px 20px', background: 'white', borderBottom: '1px solid #e2e8f0' }}>
          <input 
            type="text" 
            placeholder="부품명 또는 판매 담당자 검색..."
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box', padding: '10px 15px', border: '1px solid #fef08a', borderRadius: '8px', outline: 'none', fontSize: '13px' }}
          />
        </div>

        {/* 목록 리스트 */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px', background: '#f1f5f9', display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {filteredRecords.length > 0 ? (
            filteredRecords.map((p, idx) => (
              <div key={p.id || idx} style={{ background: 'white', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '12px' }}>
                  <span style={{ fontWeight: 'bold', color: '#ca8a04', background: '#fefce8', padding: '2px 6px', borderRadius: '4px' }}>부품출고 ({p.status || '완료'})</span>
                  <span style={{ color: '#94a3b8' }}>{p.settleDate || p.asDate}</span>
                </div>
                
                {/* 🚀 [부품 매핑 완료] 판매된 부품들의 이름과 수량을 깔끔하게 리스트업 합니다 */}
                <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#1e293b', marginBottom: '4px' }}>
                  {p.parts && p.parts.length > 0 ? (
                    p.parts.map((item, i) => (
                      <div key={i} style={{ marginBottom: '2px' }}>
                        • {item.taskName} <span style={{fontSize: '12px', color: '#64748b', fontWeight: 'normal'}}>({item.qty}개)</span>
                      </div>
                    ))
                  ) : (
                    '부품 단순 판매 내역'
                  )}
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#64748b', marginTop: '10px', borderTop: '1px dashed #f1f5f9', paddingTop: '8px' }}>
                  <span>출고담당: {p.mechanic || '-'}</span>
                  <span style={{ fontWeight: 'bold', color: '#0f172a' }}>₩ {Number(p.totalCost || 0).toLocaleString()}</span>
                </div>
              </div>
            ))
          ) : (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#94a3b8', fontSize: '13px' }}>
              조건에 맞는 부품 판매 내역이 존재하지 않습니다.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerPartsModal;